const userInfo = () => {
  const localUser = localStorage.getItem('user')
  return JSON.parse(localUser);
}
// JWT issued by POST /users/login (the only token source)
const userToken = () => localStorage.getItem('token')

const userIsLogin = () => {
  const isUser = userInfo();
  // A session needs both the profile and the token — pre-hotfix sessions have no token and must re-login
  const loggedIn = isUser !== null && !!userToken();
  localStorage.setItem('islogin', loggedIn)
  return loggedIn
}
const userRole = () => {
  const isUser = userInfo();
  return isUser.role;
}
const clearSession = () => {
  localStorage.removeItem('user')
  localStorage.removeItem('token')
  localStorage.removeItem('islogin')
}
export { userInfo, userIsLogin, userRole, userToken, clearSession }
